import { render } from "./SocialInformation.vue?vue&type=template&id=f1bc5a66"
import script from "./SocialInformation.vue?vue&type=script&lang=js"
export * from "./SocialInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__